import React from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {Table} from 'components/ui-kit/Table2.0';
import {Gate, state$} from 'models/documents/details/products/table';
import {ProductContentFormattedRow, ProductContentRawResponse} from 'types';

interface Props {
    reportId: string;
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (
        data: ProductContentRawResponse['data'] | undefined,
        t: TFunction,
    ) => ProductContentFormattedRow[];
}

export const ProductsTable = ({reportId, configFunc, dataMapper}: Props) => {
    const {t} = useTranslation();
    const {data, pageNumber, pageNumberChanged, isLoading} = useStore(state$);
    const mappedData = React.useMemo(() => dataMapper(data?.data, t), [dataMapper, data, t]);

    return (
        <>
            <Gate reportId={reportId} />
            <Table
                hideSetting={true}
                columns={configFunc(t)}
                data={mappedData}
                isLoading={isLoading}
                hasNext={!!data?.nextPageRef}
                pageIndex={pageNumber}
                onPageChange={pageNumberChanged}
            />
        </>
    );
};
